m = require 'mithril'

ExportPane = {
	view: (ctrl, args) ->
		m '.exportpane', [
			m 'h2', 'Export'
			m 'p', 'Copy the following text into the import box on another device to import your games.'
			m 'textarea.exportpane__data', {readonly: true, value: JSON.stringify args.games(), null, 2}
		]
}

module.exports = ExportPane